import { css } from '@emotion/react';

import { breakpoint } from '~/common/utils/breakpoint.utils';

import type { CSSProperties, PropsWithChildren } from 'react';

interface Props extends PropsWithChildren {
  className?: string;
  style?: CSSProperties;
}

function Container({ children, className, style }: Props) {
  return (
    <div className={className} css={styles.container} style={style}>
      {children}
    </div>
  );
}

const styles = {
  container: css`
    max-width: var(--container-max);
    margin: auto;
    padding-left: var(--space-4);
    padding-right: var(--space-4);

    ${breakpoint.md} {
      padding-left: var(--space-5);
      padding-right: var(--space-5);
    }
  `,
};

export default Container;
